import { Decimal, Lamport } from "./basic";
import { Asset } from "./Asset";
export class Value extends Decimal {
    constructor(raw) {
        super(raw);
    }
    toAsset(price, context) {
        const lamport = Lamport.of(this.raw.div(price.getRaw()).mul(context.multiplier));
        return Asset.of(price.getMintId(), lamport);
    }
    toNumber() {
        return this.raw.round(2, 0).toNumber();
    }
    print() {
        return Value.FORMATTER.format(this.toNumber());
    }
    toString() {
        return this.print();
    }
}
// eslint-disable-next-line new-cap
Value.FORMATTER = Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
});
//# sourceMappingURL=Value.js.map